import { gsap } from "gsap";

export class FloatingIcon extends HTMLElement {
  constructor() {
    super();
    // document.addEventListener("DOMContentLoaded", () => {
    //   this.init();
    // });
  }

  connectedCallback() {
    const swiperSlide = this.closest('.swiper-slide') || this.closest('swiper-slide');
    if (swiperSlide) {
      const swiperContainer = swiperSlide.closest('.swiper') || swiperSlide.closest('swiper-container');
      if (swiperContainer) {
        const runInit = () => {
          gsap.killTweensOf(this);
          this.init();
        };

        const observeActiveSlide = () => {
          const slideObserver = new MutationObserver(() => {
            if (swiperSlide.classList.contains('swiper-slide-active')) {
              runInit();
            }
          });
          slideObserver.observe(swiperSlide, { attributes: true, attributeFilter: ['class'] });
        };

        if (swiperContainer.swiper || swiperContainer.classList.contains('swiper-initialized')) {
          runInit();
          observeActiveSlide();
        } else {
          swiperContainer.addEventListener('swiperinit', () => {
            runInit();
            observeActiveSlide();
          }, { once: true });
        }
        return;
      }
    }
    this.init();
  }


  init() {
    const iconsInSection = [...this.closest('.shopify-section').querySelectorAll('floating-icon')]
    const instanceInSection = iconsInSection.indexOf(this);
    const scaleYProp = '--tw-scale-y'
    const scaleXProp = '--tw-scale-x'
    const translateYProp = '--tw-translate-y'
    const container = this.closest('.block-floating-icons') || this.closest('.shopify-section');

    //This function sets the start of the scroll animation to the current start of the window + 100vh. It can be called as a callback to another animation, which is perfect.
    const parallaxIcon = (icon) => {
      const curTop = window.scrollY;
      let scrollTl = gsap.timeline({
        scrollTrigger: {
          trigger: "body",
          start: `${curTop}px top`,
          end: `${curTop + window.innerHeight}px top`,
          scrub: true,
        },
      });

      scrollTl.fromTo(
        icon,
        {
          [translateYProp]: `0%`,
        },
        {
          [translateYProp]: `50%`,
        },
        0
      );
    };

    const fallUpIcon = (icon) => {
      return new Promise((resolve, reject) => {
        let scrollTl = gsap.timeline({
          scrollTrigger: {
            trigger: container,
          },
        });

        scrollTl.fromTo(
          icon,
          {
            opacity: 0,
            // [translateYProp]: `-100%`,
            // Fades up not down
            [translateYProp]: `50%`,
          },
          {
            delay: (iconsInSection.length > 5 ? 0.15 : 0.3) * instanceInSection,
            opacity: 1,
            [translateYProp]: `0%`,
            duration: 0.75,
            onComplete: resolve,
          }
        );
      });
    };

    const scaleIcon = (icon) => {
      const curTop = window.scrollY;
      let scrollTl = gsap.timeline({
        // scrollTrigger: {
        //   trigger: "body",
        //   start: `${curTop} top`,
        //   end: `${curTop + window.innerHeight} top`,
        //   scrub: true,
        // },
        duration: 1,
        delay: 0.3,
      });

      scrollTl.fromTo(
        icon,
        {
          opacity: 1,
          scale: 0.9,
        },
        {
          opacity: 1,
          scale: 1.3,
        },
        0
      );

      // TODO: This is def the wrong spot for this. We need a separate file for the "hitchcock-effect" screen as a whole. Multiple items in here would blow this up.
      const containerHeader = container?.querySelector('.block-header-region');
      if (containerHeader) {
        scrollTl.fromTo(
          containerHeader,
          {
            y: '50px',
            scale: 1,
          },
          {
            y: 0,
            scale: 0.9,
          },
          0
        );
      }

      const containerFooter = container?.querySelector('.block-footer-region');
      if (containerFooter) {
        scrollTl.fromTo(
          containerFooter,
          {
            y: '-50px',
            scale: 1,
          },
          {
            y: 0,
            scale: 0.9,
          },
          0
        );
      }
    };

    const popIcon = (icon) => {
      return new Promise((resolve, reject) => {
        let scrollTl = gsap.timeline({
          scrollTrigger: {
            trigger: icon.closest('.shopify-section'),
          },
        });

        scrollTl.fromTo(
          icon,
          {
            opacity: 0,
            [scaleYProp]: 0,
            [scaleXProp]: 0,
          },
          {
            delay: 0.25 + (Math.random() * 1.25),
            opacity: 1,
            [scaleYProp]: 1,
            [scaleXProp]: 1,
            ease: "bounce.out",
            duration: 0.4,
            onComplete: resolve,
          }
        );
      });
    }

    if (container?.classList.contains('hitchcock-effect')) {
      scaleIcon(this);
    }
    else {
      fallUpIcon(this); //.then(() => parallaxIcon(this));
      // popIcon(this).then(() => parallaxIcon(this));
    }
  }
}
